export default __webpack_public_path__ + "static/media/icon-check.3721848c.svg";